import { GraphQLObjectType, GraphQLString } from 'graphql';
import CourseType from './course.gql';
import getTransformedFields from '../../helper/PreviewCourseHelper/getTransformedFields';

const viewerType = new GraphQLObjectType({
  name: 'Viewer',
  fields: () => ({
    previewOffer: {
      type: CourseType,
      args: {
        offer: {
          type: GraphQLString
        }
      },
      resolve: (_, args) => {
        const transformedFields = getTransformedFields(JSON.parse(args.offer));
        return transformedFields;
      }
    }
  })
});

window[viewerType.name + 'GQLType'] = viewerType;

export default viewerType;
